interface MenuItem {
    name: string;
    link: string;
    subMenu?: MenuItem[];
}

export const getNameByPath = (
    pathName: string,
    currentMenu: MenuItem[]
): MenuItem | { name: string } => {
    const findMenuItem = (menu: MenuItem[], path: string): MenuItem | null => {
        for (const item of menu) {
            if (item) {
                if (item.link) {
                    if (item.link.replace('/', "") === path.split('/')[1]) return item
                } else if (item.subMenu) {
                    const subMenuItem = findMenuItem(item.subMenu, path);
                    if (subMenuItem) {
                        return subMenuItem;
                    }
                }
            }
        }
        return null;
    };

    const menuItem = findMenuItem(currentMenu, pathName);
    return menuItem || { name: "Dashboard" };
};

